import styled, { css } from 'styled-components';
import Typography from '../../../../typography';
import { stylePropertiesToCss } from '../../../../../design-tokens/style-mixins';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
/**
 * ReceiptDetail
 */
export const receiptDetailStyles = ({ theme }) => css `
	color: ${theme.colors.base.textPriceReceipt};
	${stylePropertiesToCss(theme.typography.numbersPricesAndUsPs['50PriceTextXs'])};

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.lg)}) {
		${stylePropertiesToCss(theme.typography.numbersPricesAndUsPs['75PriceTextSSlim'])};
	}
`;
export const StyledReceiptDetail = styled(Typography).attrs({
    tagName: 'span',
}) `
	${receiptDetailStyles}
`;
